import React, { useEffect } from 'react';
import { useLazyGetVipCustomerByCustomerCodeQuery } from '../../services';
import { VipCustomer } from './index';
import { VipCustomerTicketDto } from '../../types';

type VipCustomerProps = {
  content: string;
  customerCode: string;
  fontSize?: string;
};

const VipCustomerByCustomerCode: React.FC<VipCustomerProps> = ({ content, customerCode, fontSize }) => {
  const [fetchVipCustomer, { data: vipCustomerData }] = useLazyGetVipCustomerByCustomerCodeQuery();
  useEffect(() => {
    if (customerCode) fetchVipCustomer(customerCode);
  }, [customerCode, fetchVipCustomer]);

  return <VipCustomer content={content} customer={vipCustomerData?.data as VipCustomerTicketDto} fontSize={fontSize} />;
};

export default VipCustomerByCustomerCode;
